var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8984_107615)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.97266C8.68629 2.97266 6 5.65895 6 8.97266C6 12.2864 8.68629 14.9727 12 14.9727C15.3137 14.9727 18 12.2864 18 8.97266C18 5.65895 15.3137 2.97266 12 2.97266ZM4 8.97266C4 4.55438 7.58172 0.972656 12 0.972656C16.4183 0.972656 20 4.55438 20 8.97266C20 13.3909 16.4183 16.9727 12 16.9727C7.58172 16.9727 4 13.3909 4 8.97266Z",
    fill: "#BB85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6585 13.8613C16.206 13.7887 16.7087 14.1736 16.7813 14.7211L17.9913 23.8411C18.0418 24.2218 17.8699 24.5977 17.549 24.8085C17.2281 25.0193 16.8148 25.0277 16.4855 24.8301L12 22.1388L7.51452 24.8301C7.18525 25.0277 6.77193 25.0193 6.45099 24.8085C6.13004 24.5976 5.95817 24.2216 6.00873 23.841L7.21873 14.731C7.29145 14.1835 7.79421 13.7986 8.34169 13.8714C8.88917 13.9441 9.27403 14.4468 9.20132 14.9943L8.26447 22.0478L11.4855 20.1152C11.8022 19.9252 12.1978 19.9252 12.5145 20.1152L15.7359 22.048L14.7987 14.9842C14.7261 14.4367 15.111 13.934 15.6585 13.8613Z",
    fill: "#BB85FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8984_107615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.972656)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationsIcon);
export default __webpack_public_path__ + "static/media/certifications-icon.c6156a1e1ecf640c66c3a5a77b827504.svg";
export { ForwardRef as ReactComponent };